import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

/**
 * Grid de accesos rápidos a paneles de gestión (tickets, usuarios, proyectos...).
 * Usado por los dashboards de técnico y administrador.
 *
 * cards: [{ to, icon, color, title, description, value, valueLabel }]
 */
const DashboardQuickAccess = ({ cards, onLinkClick }) => (
  <div className="dash-quickaccess-grid">
    {cards.map(({ to, icon: Icon, color, title, description, value, valueLabel }) => (
      <Link key={to} to={to} onClick={onLinkClick} className={`dash-quickaccess-card dash-quickaccess-${color}`}>
        <div className="dash-quickaccess-icon"><Icon /></div>
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="dash-quickaccess-footer">
          <div className="dash-quickaccess-value">
            <span>{value}</span>
            <span>{valueLabel}</span>
          </div>
          <div className="dash-quickaccess-cta">
            Ir al panel <FiArrowRight />
          </div>
        </div>
      </Link>
    ))}
  </div>
);

export default DashboardQuickAccess;
